import React from 'react';
import Ratings from '../common/Rating';
import Types from '../common/Types';
import UserAvatar from '../common/UserAvatar';
import CustomDatePicker from "../common/CollapseTable/customDatePicker";
import moment from 'moment';

const tableConfig = (props) => ({
	columns: [
		{
			title: 'Invoice ID', field: 'order.invoice_id', filterAndSearch: false, width: "80px",
			render: rowData => <div>{(rowData.order && rowData.order.invoice_id) || "-"}</div>
		},
		{
			title: 'Delivery Order ID', field: 'order.delivery_task_id', filterAndSearch: false, width: "80px",
			render: rowData => <div>{(rowData.order && rowData.order.delivery_task_id) || "-"}</div>
		},
		{
			title: 'Business Name', field: 'order.food_seller.business_name', filterAndSearch: false, width: "130px",
			render: rowData => <div>{(rowData.order && rowData.order.food_seller && rowData.order.food_seller.business_name) || "-"}</div>
			// render: rowData => <UserAvatar name={rowData.name} image={rowData.dpUrl}/>
		},
		{
			title: 'Seller Type', field: 'order.food_seller.seller_type', filterAndSearch: false, width: "120px",
			render: rowData => <div>{(rowData.order && rowData.order.food_seller && rowData.order.food_seller.seller_type) || "-"}</div>
		},
		{
			title: 'Seller Name', field: 'order.food_seller.user.name', filterAndSearch: false, width: "100px",
			render: rowData => <div>{(rowData.order && rowData.order.food_seller && rowData.order.food_seller.user && rowData.order.food_seller.user.name) || "-"}</div>,
		},
		{
			title: 'Seller Address', field: 'order.food_seller.address_line1', filterAndSearch: false, width: "100px",
			render: rowData => <div>{(rowData.order && rowData.order.food_seller && rowData.order.food_seller.address_line1) || "-"}</div>,
		},
		{
			title: 'Seller Pincode', field: 'order.food_seller.pin_code', filterAndSearch: false, width: "100px",
			render: rowData => <div>{(rowData.order && rowData.order.food_seller && rowData.order.food_seller.pin_code) || "-"}</div>,
		},
		{
			title: 'Customer Name', field: 'order.food_buyer.user.name', filterAndSearch: false, width: "100px",
			render: rowData => <div>{(rowData.order && rowData.order.food_buyer && rowData.order.food_buyer.user && rowData.order.food_buyer.user.name) || "-"}</div>,
		},
		{
			title: 'Customer Address', field: 'order.food_buyer.user.name', filterAndSearch: false, width: "100px",
			render: rowData => <div>{(rowData.order && rowData.order.food_buyer && rowData.order.food_buyer.user && rowData.order.food_buyer.user.name) || "-"}</div>,
		},
		{
			title: 'Payment Date', field: 'date_system', type: "date", width: "160px", filterAndSearch: false,
			//dateSetting: { locale: "ko-KR" },
			//filterComponent: (props) => <CustomDatePicker {...props} />,
			render: rowData => <div>{rowData.date_system ? (moment.utc(rowData.date_system).local().format("DD-MM-YYYY, h:mm A")) : "-"}</div>,
		},
		{
			title: 'Mode Of Delivery', field: 'order.delivery_option.option_name', filterAndSearch: false, width: "120px",
			render: rowData => {
				const className = rowData.order && rowData.order.delivery_option && rowData.order.delivery_option.option_code === "Dunzo" ? "green-label" : "orange-label"
				return <div className={`text-capitalize colored-label ${className}`}>{(rowData.order && rowData.order.delivery_option && rowData.order.delivery_option.option_name) || "-"}</div>
			}
		},
		{
			title: 'Mode Of Payment', field: 'method', filterAndSearch: false, width: "100px",
			render: rowData => <div>{(rowData.method) || "-"}</div>,
		},
		{
			title: 'Total Bill Amount', field: 'order.amount', filterAndSearch: false,
			render: rowData => <div>{<span>&#8377;{(rowData.order && rowData.order.amount) || 0}</span>}</div>
		},
		{
			title: 'Delivery Charges', field: 'order.delivery_charges', filterAndSearch: false,
			// render: rowData => <div>{(rowData.order && rowData.order.currency === "&#8377;") ? <span>&#8377;{(rowData.order && rowData.order.tax) || 0}</span> : <span>&#36;{(rowData.order && rowData.order.tax) || 0}</span>}</div>
			render: rowData => <div>{<span>&#8377;{(rowData.order && rowData.order.delivery_charges) || 0}</span>}</div>
		},
		{
			title: 'GST & Other Charges', field: 'order.tax', filterAndSearch: false,
			// render: rowData => <div>{(rowData.order && rowData.order.currency === "&#8377;") ? <span>&#8377;{(rowData.order && rowData.order.tax) || 0}</span> : <span>&#36;{(rowData.order && rowData.order.tax) || 0}</span>}</div>
			render: rowData => <div>{<span>&#8377;{(rowData.order && rowData.order.tax) || 0}</span>}</div>
		},
		{
			title: 'Amount To Be Paid', field: 'amount', filterAndSearch: false,
			render: rowData => <div>{<span>&#8377;{rowData.amount || 0}</span>}</div>
		},
		{
			title: 'Status', field: 'payment_status', filterAndSearch: false, width: "100px",
			render: rowData => <div>{(rowData.payment_status) || "Pending"}</div>,
		}
	],
})

export const data = [
	{
		"_id": "5f3bbcf8bd2288dcdccf35d2",
		"item": "Test item",
		"orderId": 1234,
		"weight": "100gm",
		"qty": 2,
		"price": 200,
		"buyer": "Test Buyer",
		"seller": "Test Seller",
		"orderedAt": "Apr 2020",
		"status": "pending"
	},
	{
		"_id": "5f3bbcf8958c595f4833db3e",
		"item": "Test item",
		"orderId": 1234,
		"weight": "100gm",
		"qty": 2,
		"price": 200,
		"buyer": "Test Buyer",
		"seller": "Test Seller",
		"orderedAt": "Apr 2020",
		"status": "pending"
	},
	{
		"_id": "5f3bbcf8ff0a6a4cf4e81ba9",
		"item": "Test item",
		"orderId": 1234,
		"weight": "100gm",
		"qty": 2,
		"price": 200,
		"buyer": "Test Buyer",
		"seller": "Test Seller",
		"orderedAt": "Apr 2020",
		"status": "pending"
	},
	{
		"_id": "5f3bbcf8da097fceb33eda11",
		"item": "Test item",
		"orderId": 1234,
		"weight": "100gm",
		"qty": 2,
		"price": 200,
		"buyer": "Test Buyer",
		"seller": "Test Seller",
		"orderedAt": "Apr 2020",
		"status": "pending"
	},
	{
		"_id": "5f3bbcf815c275e3c40187bd",
		"item": "Test item",
		"orderId": 1234,
		"weight": "100gm",
		"qty": 2,
		"price": 200,
		"buyer": "Test Buyer",
		"seller": "Test Seller",
		"orderedAt": "Apr 2020",
		"status": "pending"
	},
	{
		"_id": "5f3bbcf8da5fef114c2204e7",
		"item": "Test item",
		"orderId": 1234,
		"weight": "100gm",
		"qty": 2,
		"price": 200,
		"buyer": "Test Buyer",
		"seller": "Test Seller",
		"orderedAt": "Apr 2020",
		"status": "pending"
	}
];

export default tableConfig;